import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import ImageSlider from '../components/ImageSlider';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section with Full-Width Slider */}
      <section className="hero-section full-width-section">
        <div className="hero-slider-full-width">
          <ImageSlider />
        </div>
        <div className="hero-info-wrapper">
          <div className="section-container">
            <div className="hero-info-section">
              <div className="hero-content">
                <div className="hero-badge">
                  <span>Professional Legal Services</span>
                </div>
                <h1 className="hero-title">
                  Ambreen Daudpota
                </h1>
                <h2 className="hero-subtitle">
                  Advocate High Court
                </h2>
                <p className="hero-description">
                  Providing expert legal representation and consultation with dedication, 
                  integrity, and years of experience in the judicial system.
                </p>
                <div className="hero-contact-info">
                  <div className="contact-item">
                    <div className="contact-icon">📞</div>
                    <div className="contact-details">
                      <span className="contact-label">Call Now</span>
                      <span className="contact-value">0333-7125176</span>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">✉️</div>
                    <div className="contact-details">
                      <span className="contact-label">Email</span>
                      <span className="contact-value">ambreendaudpota@gmail.com</span>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">📍</div>
                    <div className="contact-details">
                      <span className="contact-label">Office</span>
                      <span className="contact-value">Quresh Law Chamber, Station Road Sukkur</span>
                    </div>
                  </div>
                </div>
                <div className="hero-actions">
                  <Link to="/contact" className="btn btn-primary">Get Free Consultation</Link>
                  <Link to="/services" className="btn btn-outline">View Services</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section full-width-section">
        <div className="stats-section-full-width">
          <div className="section-container">
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-icon">⚖️</div>
                <div className="stat-number">15+</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">🏆</div>
                <div className="stat-number">500+</div>
                <div className="stat-label">Cases Won</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">👥</div>
                <div className="stat-number">1000+</div>
                <div className="stat-label">Happy Clients</div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">📈</div>
                <div className="stat-number">95%</div>
                <div className="stat-label">Success Rate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview full-width-section">
        <div className="services-preview-full-width">
          <div className="section-container">
            <div className="section-header">
              <h2 className="section-title">Legal Services</h2>
              <p className="section-subtitle">
                Comprehensive legal solutions tailored to your needs
              </p>
            </div>
            <div className="services-grid">
              <div className="service-preview-card">
                <div className="service-icon" style={{'--service-color': 'var(--accent-blue)'}}>⚖️</div>
                <h3>Civil Litigation</h3>
                <p>Expert representation in civil disputes and legal matters</p>
              </div>
              <div className="service-preview-card">
                <div className="service-icon" style={{'--service-color': 'var(--accent-teal)'}}>🏛️</div>
                <h3>Criminal Defense</h3>
                <p>Skilled defense in criminal cases with thorough preparation</p>
              </div>
              <div className="service-preview-card">
                <div className="service-icon" style={{'--service-color': 'var(--accent-purple)'}}>👨‍👩‍👧‍👦</div>
                <h3>Family Law</h3>
                <p>Compassionate handling of family and matrimonial matters</p>
              </div>
            </div>
            <div className="services-cta">
              <Link to="/services" className="btn btn-secondary">View All Services</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section full-width-section">
        <div className="why-choose-section-full-width">
          <div className="section-container">
            <div className="why-choose-content">
              <div className="why-choose-text">
                <h2 className="section-title">Why Choose Ambreen Daudpota?</h2>
                <div className="features-list">
                  <div className="feature-item">
                    <div className="feature-icon">🎓</div>
                    <div className="feature-content">
                      <h4>Expert Legal Knowledge</h4>
                      <p>Extensive experience in High Court proceedings and legal expertise</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">🤝</div>
                    <div className="feature-content">
                      <h4>Client-Focused Approach</h4>
                      <p>Personalized attention and dedicated service for every client</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">⏰</div>
                    <div className="feature-content">
                      <h4>Timely Resolution</h4>
                      <p>Efficient handling of cases with focus on quick resolution</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="why-choose-image">
                <div className="image-placeholder">
                  <div className="scales-large">
                    <svg viewBox="0 0 200 200" className="scales-svg">
                      <path d="M100 20 L60 60 L140 60 Z" fill="var(--primary-gold)"/>
                      <circle cx="60" cy="70" r="30" fill="none" stroke="var(--primary-gold)" strokeWidth="3"/>
                      <circle cx="140" cy="70" r="30" fill="none" stroke="var(--primary-gold)" strokeWidth="3"/>
                      <line x1="100" y1="60" x2="100" y2="160" stroke="var(--primary-gold)" strokeWidth="4"/>
                      <path d="M90 150 L110 150 L104 170 L96 170 Z" fill="var(--primary-gold)"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
